var render = function render(){var _vm=this,_c=_vm._self._c;return _c('basicLayout',[(_vm.name.id)?_c('OrderLines',{attrs:{"name":_vm.name,"filter":"name","origin":"OrdersByName","parent_can_supply_filter":"all"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }